function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-flag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 6.9998C2.96732 6.54173 3.59562 6.28516 4.25 6.28516C4.90438 6.28516 5.53268 6.54173 6 6.9998C6.46732 7.45787 7.09562 7.71444 7.75 7.71444C8.40438 7.71444 9.03268 7.45787 9.5 6.9998V2.4998C9.03268 2.95787 8.40438 3.21444 7.75 3.21444C7.09562 3.21444 6.46732 2.95787 6 2.4998C5.53268 2.04173 4.90438 1.78516 4.25 1.78516C3.59562 1.78516 2.96732 2.04173 2.5 2.4998V6.9998ZM2.5 6.9998V10.4998",
    stroke: "#B42318",
    style: {
      stroke: "#B42318",
      stroke: "color(display-p3 0.7040 0.1365 0.0960)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/icon-flag.b74614d939bc2e407f4375e9b1e5dce5.svg";
export { ForwardRef as ReactComponent };